import { render, staticRenderFns } from "./SortableElTable.vue?vue&type=template&id=151dfd69&"
import script from "./SortableElTable.vue?vue&type=script&lang=js&"
export * from "./SortableElTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports